import {NgModule} from "@angular/core";
import {CommonModule, DatePipe, NgOptimizedImage} from "@angular/common";

import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {QuillEditorComponent, QuillViewComponent} from "ngx-quill";
import {NgxMaterialTimepickerModule} from "ngx-material-timepicker";
import {UserAvatarComponent} from "./Components/user-avatar/user-avatar.component";
import {ColorPickerModule} from "ngx-color-picker";
import {ExtractUsernamePipe} from "../../customPipes/extract-username.pipe";
import {
    ArrowUpDown,
    Bell,
    Bold,
    Box,
    Braces,
    Bug,
    Calculator,
    Calendar,
    CalendarX2,
    Check,
    ChevronDown,
    ChevronsUpDown,
    ChevronUp,
    CircleArrowDown,
    CircleMinus,
    CircleUserRound,
    Cog,
    Database,
    DollarSign,
    Download,
    File,
    FileText,
    GitBranch,
    Hash,
    Headset,
    History,
    Image,
    Info,
    Italic,
    LayoutDashboard,
    Link,
    List,
    ListOrdered,
    LucideAngularModule,
    Megaphone,
    MessageSquare,
    Mic,
    Minus,
    MonitorSmartphone,
    Network,
    Paperclip,
    Pencil,
    PencilRuler,
    Plane,
    Play,
    Plus,
    RefreshCcw,
    RefreshCw,
    Repeat2,
    Rocket,
    RotateCcw,
    RotateCw,
    Rows3,
    Scale,
    Search,
    SendHorizontal,
    Shield,
    ShieldMinus,
    ShieldPlus,
    Smile,
    Sparkle,
    SquareCheckBig,
    StickyNote,
    Strikethrough,
    Trash2,
    TriangleAlert,
    Underline,
    User,
    UserPlus,
    Users,
    Video,
    WifiOff,
    X,
    ChevronLeft,
    ChevronRight,
    Clock9,
    CircleUser,
    Settings2,
    Building2,
    PackageCheck,
    ChartNoAxesCombined,
    MoreHorizontal
} from "lucide-angular";
import {FileSizeByteToMbPipe} from "./Pipes/file-size-byte-to-mb.pipe";

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        QuillEditorComponent,
        NgxMaterialTimepickerModule,
        QuillViewComponent,
        NgOptimizedImage,
        UserAvatarComponent,
        ColorPickerModule,
        ExtractUsernamePipe,
        LucideAngularModule.pick({
            User,
            X,
            Hash,
            ChevronDown,
            ChevronUp,
            ChevronLeft,
            ChevronRight,
            Plus,
            UserPlus,
            History,
            Download,
            Mic,
            StickyNote,
            Bell,
            Search,
            TriangleAlert,
            SquareCheckBig,
            Repeat2,
            Bug,
            Users,
            Video,
            Check,
            Info,
            Minus,
            Pencil,
            RefreshCcw,
            PencilRuler,
            Braces,
            Cog,
            Box,
            DollarSign,
            Megaphone,
            Headset,
            Calculator,
            Network,
            Database,
            Shield,
            Rocket,
            Scale,
            CircleUserRound,
            ShieldPlus,
            ShieldMinus,
            CircleMinus,
            WifiOff,
            Image,
            ArrowUpDown,
            CircleArrowDown,
            ChevronsUpDown,
            GitBranch, Trash2,
            Sparkle,
            LayoutDashboard,
            Calendar, CalendarX2,
            Plane,
            MonitorSmartphone,
            File,
            FileText,
            MessageSquare,
            Play,
            RefreshCw,
            RotateCcw,
            RotateCw,
            Rows3,
            Bold,
            Italic,
            Underline,
            Strikethrough,
            Link,
            List,
            ListOrdered,
            Paperclip,
            Smile,
            SendHorizontal,
            Clock9,
            CircleUser,
            Settings2,
            Building2,
            PackageCheck,
            ChartNoAxesCombined,
            MoreHorizontal
        }),
        FileSizeByteToMbPipe,
    ],
    exports: [CommonModule, LucideAngularModule],
    providers: [DatePipe],
})
export class SharedModule {
}
